import React  from 'react';
import InputTableApp from "../Functionality/InputTableApp";
import CreateInputModal from "../../Inputs/Modal/CreateInputModal";
import DeleteModal from "../../../../Modals/DeleteModal";
import CustomTable from "../../../../../components/table/CustomTable";
import {ButtonLargeTransparent} from "../../../../../components/buttons/ButtonLargeTransparent";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {TrashOutlineIcon} from "../../../../../components/buttons/IconButtons";
import DividerWithText from "../../../../../components/DividerWithText";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const InputTable = ({ defaultSioList }) => {
    const {
        t,
        id,
        thead,
        tbody,
        tableId,
        selectedList,
        isAllChecked,
        deleteInputShow,
        setDeleteInputShow,
        showCreateInputModal,
        setShowCreateInputModal,
        setModified,
        handleCheckboxChange,
        handleDeleteAll,
        deleteSelectedInput
    } = InputTableApp({ defaultSioList });

    return (
        <>
            <div className='row mt-4'>
                <DividerWithText title={t('inputs')} />
                <div className='d-flex justify-content-end mb-2'>
                    <ButtonAction
                        id='btn_it_delete_input'
                        name='delete'
                        className='btn-icon-delete'
                        disabled={selectedList?.length === 0}
                        Icon={TrashOutlineIcon}
                        onClick={() => {
                            setDeleteInputShow(true);
                        }}
                    />
                </div>
                <CustomTable
                    tableId={tableId}
                    checkbox={true}
                    checkboxTitle={"de_/_select_all"}
                    isAllChecked={isAllChecked}
                    onChangeCheckbox={handleDeleteAll}
                    handleCheckboxChange={handleCheckboxChange}
                    selectedList={selectedList}
                    thead={thead}
                    tbody={tbody}
                    columnActions={false}
                    withoutHeight={true}
                />
                <div className='my-2'>
                    <ButtonLargeTransparent
                        id="btn_it_create_input"
                        click={() => {
                            setShowCreateInputModal(true);
                        }}
                        text={t("create_input")}
                    />
                </div>

            </div>

            {showCreateInputModal &&
                <CreateInputModal
                    controllerId={id}
                    show={showCreateInputModal}
                    onHide={() =>  setShowCreateInputModal(false)}
                    setModified={setModified}
                />
            }

            <DeleteModal
                show={deleteInputShow}
                onHide={() => setDeleteInputShow(false)}
                onClickFn={() => deleteSelectedInput()}
                data={selectedList}
                title_modal={t('delete_input')}
                description={'are_you_sure_you_want_to_delete'}
                element_modal={t('inputs')}
            />
        </>
    );
};

export default InputTable;
